import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Test from './Test'

ReactDOM.render(
  <React.StrictMode>
    <App />
    {/* <Test /> */}
  </React.StrictMode>,
  document.getElementById('root')
)
